import {Button} from "@mui/material";

export default function BackButton({btnText}) {

  return (
    <Button
      onClick={() => {
        window.history.go(-1)
      }}
      style={{backgroundColor: '#ececec'}}
    >
      {btnText || 'Back'}
    </Button>
  )
}
